import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
// import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import { LangCtx } from "../../../lib/context";

const LicenseExpiryPopup = (props) => {
    const { l } = useContext(LangCtx);

    const history = useHistory();
    return (
        <div className={props.openDelete ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                    {/* <span className="hdrTxt">{`Delete ${props.header}`}</span> */}
                    <span>{l.licence_expire}</span>
                </div>

                <div className="btmDtlBdy">
                    {/* {props.msg != null ?
                        <span className="summaryTxt"> {props.msg ? props.msg : ''}? </span> :
                        <span className="summaryTxt">{l.conf_del}  {props.data.firstName ? props.data.firstName : ''}? </span>} */}

                    <span className="summaryTxt">
                        {l.license_within} {props.days} {l.days}, {l.renew_license}
                    </span>
                </div>

                <div className="hdrAction">
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={() => history.push("/clinic-license")}>
                            Renewal
                        </span>
                    </div>
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={() => props.closeCallback()}>
                            Ignore
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LicenseExpiryPopup;
